import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {LogoGold} from 'ui/logo';

const Screen = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '40px 24px',
  backgroundColor: colors.darkBrown,
  textAlign: 'center',
});

const Message = styled('p')({
  maxWidth: 520,
  margin: 0,
  color: colors.white,
  fontFamily: fonts.default,
  fontSize: 20,
  lineHeight: '30px',
});

const Address = styled('strong')({
  display: 'block',
  marginTop: 12,
  color: colors.caramel,
  fontSize: 22,
});

const DesktopNotice = () => (
  <Screen>
    <LogoGold />
    <Message>
      Utilisez votre téléphone pour accéder à l’application avec l’adresse suivante&nbsp;:
      <Address>maison.cartedor.fr/pwa</Address>
    </Message>
  </Screen>
);

export default DesktopNotice;
